import React, {useCallback} from 'react';
import {useFullpagePanel, useGetNavigationData} from 'hooks';

import './SidePanelTitle.scss';
import {ReactComponent as CloseIcon} from 'assets/icons/close-circle.svg';
import {FSMStore} from 'webgl/stores';

type SidePanelTitleProps = {
  marker?: string;
  title?: string;
  fullpage?: boolean;
  offset?: boolean;
}

const SidePanelTitle: React.FC<SidePanelTitleProps> = ({marker, title, fullpage, offset = false}) => {
  const setFSMState = FSMStore(state => state.setFSMState);

  // const [fullpage,] = useFullpagePanel();

  const [, , , , parentState] = useGetNavigationData();
  const gotoParentState = useCallback(() => parentState && setFSMState(parentState), [parentState, setFSMState/*, currentFSMState*/]);

  return (
    <div className={`side-panel-title ${fullpage ? 'fullpage' : 'right'} ${offset ? 'offset-title' : ''}`} style={{paddingRight: !title ? '0.625rem' : ''}}>
      <svg className="side-panel-title-marker">
        <circle id="backCircle"/>
        <circle id="frontCircle"/>
        <text x="50%" y="50%" dy=".3em">{marker}</text>
      </svg>

      {title && <div className="side-panel-title-text">{title}</div>}

      {offset ? /*TODO trick to display close button when in solutions sub state, because it's the only one with offset */
        <div className="close-btn" onClick={gotoParentState}><CloseIcon/></div>
        : null}
    </div>
  );
};

export default SidePanelTitle;